// Generated by scripts/build-ui-icons.mjs.
export { CalendarBlank as default } from "../ui/glyphs-2";
